import withHelmet from '../HOC/withHelmet';
import PrivacyPage from '../components/privacy';

export default withHelmet(PrivacyPage, 'Privacy');
